<template>
    <div class="grid grid-cols-6 gap-6">

       <div class="col-span-6 sm:col-span-3 lg:col-span-2">
            <label for="tipo_cap" class="block text-sm font-medium text-gray-700">
                Tipo CAP <span :class="view===''?'hidden':'font-bold text-red-700'">(*)</span>
            </label>
            <select id="tipo_cap" v-model="collectionData.id_tipo_cap" :disabled="view===''"
                    class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
                    <option value="" selected>Seleccione tipo de CAP...</option>
              <template v-if="selectTipoCap && selectTipoCap[0]">
                <option v-for="tipoCapOption in selectTipoCap[0]" :key="tipoCapOption.id" :value="tipoCapOption.id"
                        :selected="collectionData.id_tipo_cap === tipoCapOption.id">
                  {{ tipoCapOption.nombre }}
                </option>
              </template>
            </select>
        </div>

        <div class="col-span-6 sm:col-span-3 lg:col-span-2">
          <label for="numero" class="block text-sm font-medium text-gray-700">Número CAP <span
              :class="view===''?'hidden':'font-bold text-red-700'">(*)</span></label>
          <input type="text" id="numero" v-model="collectionData.numero"
                @change="(newNumero)=>$emit('updateValues', {'numero':customUpdateValueData('numero',newNumero.target.value)})"
                class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
        </div>
        <div class="col-span-6 sm:col-span-3 lg:col-span-2">
          <label for="fecha_expedicion" class="block text-sm font-medium text-gray-700">Fecha Expedición CAP <span
              :class="view===''?'hidden':'font-bold text-red-700'">(*)</span></label>
          <input type="date" :disabled="view===''" id="fecha_expedicion" v-model="collectionData.fecha_expedicion"
                @change="(newFechaExpedicion)=>$emit('updateValues', {'fecha_expedicion':customUpdateValueData('fecha_expedicion',newFechaExpedicion.target.value)})"
                class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
        </div>
        <div class="col-span-6 sm:col-span-3 lg:col-span-2">
          <label for="valor_cap" class="block text-sm font-medium text-gray-700">Valor CAP <span
              :class="view===''?'hidden':'font-bold text-red-700'">(*)</span></label>
          <input type="text" :disabled="view===''" id="valor_cap" v-model="collectionData.valor_cap"
                @change="(newValor)=>$emit('updateValues', {'valor_cap':customUpdateValueData('valor_cap',newValor.target.value)})"
                class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
        </div>

        <div class="col-span-6 sm:col-span-3 lg:col-span-2">
          <label for="valor_actual" class="block text-sm font-medium text-gray-700">Valor Actual Pasivo</label>
          <input type="text" id="valor_actual" v-model="collectionPasivo.valor_actual" readonly
              class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm readonly-input">
        </div>

        <div class="col-span-6 sm:col-span-3 lg:col-span-2">
          <label for="tipo_acto_administrativo" class="block text-sm font-medium text-gray-700">Acto administrativo (Ordenanza / Decreto)</label>
          <select id="tipo_acto_administrativo" v-model="collectionData.tipo_acto_administrativo"
                  class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
            <option :value="null">Seleccione un tipo de acto...</option>
            <option value="ordenanza">Ordenanza</option>
            <option value="decreto">Decreto</option>
          </select>
        </div>

        <div v-if="collectionData.tipo_acto_administrativo" class="col-span-6 sm:col-span-3 lg:col-span-2">
          <label for="fecha_expedicion_acto" class="block text-sm font-medium text-gray-700">Fecha de expedición del acto <span class="font-bold text-red-700">(*)</span></label>
          <input type="date" id="fecha_expedicion_acto" v-model="collectionData.fecha_expedicion_acto"
                class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
        </div>


         <div class="col-span-6 flex justify-center">
          <button @click="handleSave" class="px-4 py-2 text-white bg-blue-500 rounded-md hover:bg-blue-600 focus:outline-none">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="inline-block w-6 h-6">
              <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7"></path>
            </svg>
            <span class="ml-3">Guardar</span>
          </button>

          <button @click="handleBack" class="px-4 py-2 text-white bg-green-500 ml-3 rounded-md hover:bg-green-600 focus:outline-none">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="inline-block w-6 h-6">
                <path stroke-linecap="round" stroke-linejoin="round" d="M11 19l-7-7 7-7"></path>
            </svg>
            <span class="ml-3">Volver</span>
          </button>
        </div>

      </div>
  </template>
  
<script>
import { separateNumberByCommaInput, swal } from "@/common/constants";
import { nextTick, onMounted, ref, watchEffect } from "vue";
import {saveUpdateData } from "@/layouts/main";

  export default {
    name: 'EdicionCAPComponent',
    props: ['view','selectedData', 'data', 'loadData', 'dataCap',
    'entity', 'customUpdateLoadData', 'customUpdateValueData', 'customCreateActions','customUpdateCollectionData'],
    emits: ["updateValues", "customSaveData", 'updateDataCap'],
    data() {
        return {
            pasivoExigible:'',
            tipoCap: '',
            numeroCAP: '',
            fechaExpedicion: '',
            valorCAP: '',
        };
    },
    setup(props) {
      const collectionData = ref([]);
      const collectionPasivo = ref([]);
      const selectTipoCap = ref({});
      
      const fetchData = async () => {
        const id = props.dataCap;
        try {
          const apiUrl = `${process.env.VUE_APP_NEST_CAP_CONSULTA}/${id}`;
          const response = await fetch(apiUrl, {
            method: 'GET',
            headers: {
              Authorization: `Bearer ${props.authToken}`,
            },
          });

          if (!response.ok) {
            throw new Error(`Error al obtener datos: ${response.statusText}`);
          }
          collectionData.value = await response.json();
          const idPasivoExigible = collectionData.value.id_pasivo_exigible;

          try {
            const apiUrl = process.env.VUE_APP_NEST_PASIVOEXIGIBLE_FINDONE.replace(':id', idPasivoExigible);
            const response = await fetch(apiUrl, {
              method: 'GET',
              headers: {
                Authorization: `Bearer ${props.authToken}`,
              },
            });

            if (!response.ok) {
              throw new Error(`Error al obtener datos: ${response.statusText}`);
            }
            collectionPasivo.value = await response.json();
          } catch (error) {
            console.error(error);
          }

        } catch (error) {
          console.error(error);
        }
      };

      
      fetchData();
    
      watchEffect(() => {
                console.log('antes',collectionData.value.valor_cap)
                console.log('antes',collectionPasivo.value.valor_actual)
                nextTick(() => {
                    if (collectionData.value && collectionData.value.valor_cap) {
                        collectionData.value.valor_cap = separateNumberByCommaInput(collectionData.value.valor_cap);
                        // console.log('despues',collectionData.value.valor_cap)
                    }
                    if (collectionPasivo.value && collectionPasivo.value.valor_actual) {
                      collectionPasivo.value.valor_actual = separateNumberByCommaInput(collectionPasivo.value.valor_actual);
                        // console.log('despues',collectionData.value.valor_cap)
                    }
                });
        });

        onMounted(async () => {
            try {
                console.log('Antes de cargar datos');
                selectTipoCap.value = await Promise.all(props.customCreateActions?.map(async action => await action()));
                console.log('Datos cargados:', selectTipoCap.value);
            } catch (error) {
                console.error('Error al obtener datos para el select:', error);
            }
        });



        return {
          collectionData,
          selectTipoCap,
          collectionPasivo
        }; 
    },
    methods: {
      handleBack() {
        this.$emit('updateValues', { 'view': 'ver_caps' });
      },

      async handleSave() {
        this.errores = [];
        const fechaExpedicionDate = new Date(this.collectionData.fecha_expedicion);
        const fechaActual = new Date();

        if (parseFloat(this.collectionData.valor_cap) <= 0) {
            this.errores.push('El valor del CAP no puede ser negativo o menor que cero.');
        } 

        if (parseFloat(this.collectionData.valor_cap) > parseFloat(this.loadData.valor_actual)) {
            this.errores.push('El valor ingresado debe ser inferior al Valor Actual Pasivo.');
        }

        if (fechaExpedicionDate > fechaActual) {
            this.errores.push('La fecha de expedición no puede ser mayor que la fecha actual.');
        }

        if (this.collectionData.tipo_acto_administrativo && !this.collectionData.fecha_expedicion_acto) {
            this.errores.push('Debe indicarse la fecha de expedición del acto administrativo.');
        }

        if (this.errores.length > 0) {
            const errorMessage = this.errores.join('<br>');
                await swal.fire({
                    title: 'Error',
                    html: errorMessage,
                    icon: 'error',
                });
            return;
        }

        console.log('Clic en el botón de guardar');

        const id = this.dataCap;
        const informacion_cap = {
            id_tipo_cap: this.collectionData.id_tipo_cap,
            numero: this.collectionData.numero,
            id_pasivo_exigible: this.selectedData.id,
            fecha_expedicion: this.collectionData.fecha_expedicion,
            valor_cap: this.collectionData.valor_cap,
            tipo_acto_administrativo: this.collectionData.tipo_acto_administrativo || null,
            fecha_expedicion_acto: this.collectionData.tipo_acto_administrativo ? (this.collectionData.fecha_expedicion_acto || '').split('T')[0] : null,
        };
        informacion_cap.valor_cap = informacion_cap.valor_cap.replace(/,/g, '');
        await this.customSaveData(informacion_cap,id);
        },


        async customSaveData(informacion_cap, id) {
            try {
            const apiUrl = process.env.VUE_APP_NEST_CAP_UPDATE;
            const listApi = { update: apiUrl };
            const combinedData = {
                ...informacion_cap,
                id,
            };
            const resJSON = await saveUpdateData({
                selectedData: combinedData, 
                listApi,
                authToken: this.authToken,
                loadData: informacion_cap,
                action: 'actualizar',
                entity: this.entity,
            }, undefined, false, false);

            console.log('resJson', resJSON);
            this.$emit('updateValues', { 'view': 'ver_caps' });
            }catch (error) {
            console.error('Error al guardar:', error);
            }
        },
    },
  };
  
</script>

